module.exports = __webpack_public_path__ + "static/bell-dc51e80e3949fe405d2d230c574ac85e.svg";